import React, { Component, Fragment } from 'react';
import { virtualize } from 'react-swipeable-views-utils';
import SwipeableViews from 'react-swipeable-views';
import SectionBlock from './../../../../SectionBlock/SectionBlock';
import { swipeView } from './../../../../../../SwipeView/SwipeView';
import Dropdown from './../../../../../../Dropdown/Dropdown';
import ReportSwipeViewWrapper from './../../../../ReportSwipeViewWrapper/ReportSwipeViewWrapper';
import ScoreDisplayTypes from './../../../../../constants/ScoreDisplayTypes';
import ReportHelper from './../../../../../helpers/ReportHelper';
import ScoreBarTypes from './../../../../../constants/ScoreBarTypes';
import ScoreBarNG from './../../../../../components/ScoreBarNG/ScoreBarNG';

// eslint-disable-next-line css-modules/no-unused-class
import style from './style/influencingstyles.scss';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);
const InfluencingStylesSwipeView = swipeView(VirtualizeSwipeableViews);

export default class InfluencingStylesAttachment extends Component {
    constructor(props) {
        super(props);

        this.getSlideContent = this.getSlideContent.bind(this);
        this.handleSwipeChange = this.handleSwipeChange.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.changeSlide = this.changeSlide.bind(this);

        this.state = {
            activeStep: 0
        };
    }

    getSlideContent(index) {
        const { content } = this.props;
        const scoreData = content.scores[index];

        if (!scoreData) {
            return null;
        }

        return (
            <ul key={`slide-${index}`}>
                <li className={ style.mainScale__item }>
                    { scoreData.lowDefinition }
                </li>
                <li className={ style.mainScale__item }>
                    <ScoreBarNG
                        classes={{
                            displayScore: style.displayScore
                        }}
                        scoreValue={ scoreData.score }
                        displayScore={ scoreData.displayScores ? ReportHelper.getScoreType(scoreData.displayScores, ScoreDisplayTypes.NORM5, 1) : null }
                        scoreBarType={ ScoreBarTypes.BAR_GRAPH }
                    />
                    <ul>
                        <p className={ style.lowLabel }>{ scoreData.lowLabel }</p>
                        <p className={ style.highLabel }>{ scoreData.highLabel }</p>
                    </ul>
                </li>
                <li className={ style.mainScale__item }>
                    { scoreData.highDefinition }
                </li>
            </ul>
        );
    }

    getScaleSelectionOptions() {
        const scaleSelectionOptions = [];
        const { content } = this.props;

        if (!content || !content.scores) {
            return null;
        }

        content.scores.forEach((score, index) => {
            scaleSelectionOptions.push(
                <option
                    value={ index }
                    key={ `scale_${index}` }
                >
                    { score.name }
                </option>
            );
        });

        return scaleSelectionOptions;
    }

    handleSwipeChange(activeStep) {
        this.setState({
            activeStep
        });
    }

    handleBack() {
        this.setState({
            activeStep: this.state.activeStep - 1 > -1
                ? this.state.activeStep - 1
                : this.props.content.scores.length - 1
        });
    }

    handleNext() {
        this.setState({
            activeStep: this.state.activeStep + 1 >= this.props.content.scores.length
                ? 0
                : this.state.activeStep + 1
        });
    }

    changeSlide() {
        this.setState({
            activeStep: parseInt(event.target.value, 0)
        });
    }

    render() {
        const { content, i18nParticipation } = this.props;

        return <Fragment>
            <div className={ style.influencing_styles }>

                { content.definition
                    ? <SectionBlock classes={{ root: style.sectionBlockBlue }}>
                        <p dangerouslySetInnerHTML={{ __html: content.definition }}/>
                    </SectionBlock>
                    : null
                }
                <ul className={ style.influencing_styles__titleSectionContainer }>
                    <li className={ style.influencingStylesTitleSectionContainer__side }/>
                    <div>
                        <Dropdown
                            title={ i18nParticipation.report_select_a_scale }
                            onChange={ event => {
                                this.changeSlide(event);
                            }}
                            value={ this.state.activeStep }
                            classes={{
                                root: style.influencing_styles__dropdown,
                                optionSelection: style.influencing_styles__optionSelection
                            }}
                        >
                            { this.getScaleSelectionOptions() }
                        </Dropdown>
                    </div>
                    <li className={ style.influencingStylesTitleSectionContainer__side }/>
                </ul>
                <ReportSwipeViewWrapper
                    handleBack={ this.handleBack }
                    handleNext={ this.handleNext }
                    classes={
                        {
                            swipeContent: style.influencing_styles__swipeContent
                        }
                    }
                >
                    <InfluencingStylesSwipeView
                        getSlideContent={ this.getSlideContent }
                        activeIndex={ this.state.activeStep }
                        slideCount={ content.scores.length }
                        onChangeIndex={ this.handleSwipeChange.bind(this) }
                        enableMouseEvents
                    />
                </ReportSwipeViewWrapper>
            </div>
        </Fragment>;
    }
}
